"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPropertyKeys = findPropertyKeys;
exports.scanProviderPropertyMetaDates = scanProviderPropertyMetaDates;
require("reflect-metadata");
function findPropertyKeys(instance) {
    const keys = Object.keys(instance);
    const propertyKeys = Object.getOwnPropertyNames(instance.constructor.prototype).filter((name) => name !== 'constructor');
    return [...keys, ...propertyKeys];
}
function scanProviderPropertyMetaDates(instance, metadataKey, cb) {
    for (const propertyKey of findPropertyKeys(instance)) {
        const metadata = Reflect.getMetadata(metadataKey, instance, propertyKey);
        if (metadata) {
            cb(propertyKey, metadata, metadataKey);
        }
    }
}
//# sourceMappingURL=utils.js.map